import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { shouldShowMobileDock } from 'components/navigation/mobileRouteChrome';
import { NotificationDropdown } from 'components/notifications';
import { ROUTES } from 'constants/routes';
import MobileBottomNav from './MobileBottomNav';

export default function Navbar({ layoutType = 'empresa' }) {
  const location = useLocation();

  return (
    <>
      <nav className="fixed left-0 right-0 top-0 z-40 border-b border-[var(--rely-border-subtle)] bg-[var(--rely-surface-panel)]/95 shadow-[var(--rely-shadow-panel)] backdrop-blur-xl xl:hidden">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link
            to={ROUTES.HOME}
            className="flex min-h-11 items-center rounded-[var(--rely-radius-control)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
          >
            <img
              src="/rely_transparente.png"
              alt="Rely"
              className="h-8 w-auto invert dark:invert-0"
            />
          </Link>
          <NotificationDropdown />
        </div>
      </nav>

      {shouldShowMobileDock(location.pathname, { layoutType }) && (
        <MobileBottomNav />
      )}
    </>
  );
}
